import currencyJSON from "./constants/currency.json";

export const formatAmount = (
    amount = 0,
    currency = 'NGN',
    maximumSignificantDigits = 10
): string => {
    const currencySymbol = currencyJSON?.[currency as keyof typeof currencyJSON]?.['symbol'];

    const formatter = new Intl.NumberFormat('en-US', {
        // maximumSignificantDigits,
        minimumFractionDigits: 2,
    });

    return `${currencySymbol}${formatter.format(amount)}`;
};

export const formatCommaSeparated = (num: number) => num?.toLocaleString();